import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bc9d28b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "defualt" }
const _hoisted_2 = { class: "crosswise two" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "工单编号", -1))
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "工单标题", -1))
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "crosswise two" }
const _hoisted_10 = { class: "block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "工单状态", -1))
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "工单类型", -1))
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "crosswise two" }
const _hoisted_17 = { class: "block" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "创建类型", -1))
const _hoisted_19 = { class: "info" }
const _hoisted_20 = { class: "block" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "创建时间", -1))
const _hoisted_22 = { class: "info" }
const _hoisted_23 = { class: "crosswise one" }
const _hoisted_24 = { class: "block" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "详细地址", -1))
const _hoisted_26 = { class: "info" }
const _hoisted_27 = { class: "crosswise one" }
const _hoisted_28 = { class: "block" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "工单描述", -1))
const _hoisted_30 = { class: "info vertical" }
const _hoisted_31 = { style: {"user-select":"text"} }
const _hoisted_32 = { style: {"padding-bottom":"0.1rem"} }
const _hoisted_33 = { class: "crosswise one" }
const _hoisted_34 = { class: "block" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "工单附件", -1))
const _hoisted_36 = { class: "info" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "crosswise two" }
const _hoisted_39 = { class: "block" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label time" }, " 预计完成时间 ", -1))
const _hoisted_41 = { class: "info" }
const _hoisted_42 = {
  key: 0,
  class: "countdown"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "countdown-icon" }, null, -1))
const _hoisted_44 = { class: "countdown-cotent" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("距离结束还剩： ")
const _hoisted_46 = { class: "time" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "天", -1))
const _hoisted_48 = { class: "time" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "小时", -1))
const _hoisted_50 = { class: "time" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "分钟", -1))
const _hoisted_52 = { class: "time" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "秒", -1))
const _hoisted_54 = {
  key: 1,
  class: "overdue"
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  key: 1,
  class: "due"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_PreviewGroup = _resolveComponent("PreviewGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.ticketDetail.orderCode), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.ticketDetail.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.ticketDetail.status ? _ctx.ticketStatus[_ctx.ticketDetail.status-1]?.title : '--'), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.allTicketTypeList[_ctx.ticketDetail.type - 1]?.label || ''), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.orderTypeList[_ctx.ticketDetail.orderType]), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.ticketDetail.createDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, _toDisplayString((_ctx.ticketDetail.lon && _ctx.ticketDetail.lat) ? _ctx.ticketDetail.address + ' （' +Number(_ctx.ticketDetail.lon).toFixed(3)+'，'+Number(_ctx.ticketDetail.lat).toFixed(3)+'）' : _ctx.ticketDetail.address), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", null, [
            _createElementVNode("pre", _hoisted_31, _toDisplayString(_ctx.ticketDetail.describetion), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_PreviewGroup, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileLists, (cur) => {
                  return (_openBlock(), _createBlock(_component_Image, {
                    key: cur,
                    width: '1.2rem',
                    height: '1rem',
                    src: cur,
                    fallback: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                  }, null, 8, ["width", "src"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("ul", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFileLists, (i, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              onClick: ($event: any) => (_ctx.openFile(i)),
              style: {"cursor":"pointer","color":"blue"}
            }, _toDisplayString(_ctx.textFileNameLists[index]), 9, _hoisted_37))
          }), 128))
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.ticketDetail.handleTimeLimit), 1),
        (_ctx.countdown.isFinish)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("span", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.countdown.days), 1),
                _hoisted_47,
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.countdown.hours), 1),
                _hoisted_49,
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.countdown.minutes), 1),
                _hoisted_51,
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.countdown.seconds), 1),
                _hoisted_53
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_54, [
              (_ctx.countdown.finishInTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_55, "已逾期"))
                : (_openBlock(), _createElementBlock("span", _hoisted_56, "未逾期"))
            ]))
      ])
    ], 512), [
      [_vShow, _ctx.ticketDetail.status !== '1']
    ])
  ]))
}